// Wrapper de API para convites por e-mail (PO1-2046).

import api from "./api";

export async function listInvites({ idEmbarcador } = {}) {
  const params = {};
  if (idEmbarcador !== null && idEmbarcador !== undefined) {
    params.embarcadorId = idEmbarcador;
  }
  const { data } = await api.get("/admin/users/invites", { params });
  return data;
}

export async function createInvites({ emails, roleIds, idEmbarcador }) {
  const payload = { emails, roleIds };
  if (idEmbarcador) payload.idEmbarcador = idEmbarcador;
  const { data } = await api.post("/admin/users/invites", payload);
  return data;
}

export async function cancelInvite(jti) {
  const { data } = await api.delete(`/admin/users/invites/${jti}`);
  return data;
}

export async function resendInvite(jti) {
  const { data } = await api.post(`/admin/users/invites/${jti}/resend`);
  return data;
}

// Endpoints públicos (chamados na tela /auth/register?token=)
export async function previewInvite(token) {
  const { data } = await api.get("/auth/registration/invite/preview", {
    params: { token },
  });
  return data;
}

export async function acceptInvite({ token, name, surname, userName, password }) {
  const { data } = await api.post("/auth/registration/accept-invite", {
    token,
    name,
    surname,
    userName,
    password,
  });
  return data;
}
